export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      default: "inline-start",
    },
    title: {
      type: [String, Boolean],
      default: false,
    },
    offset: {
      type: String,
      default: "0px",
    },
    shader: {
      type: Boolean,
      default: true,
    },
    dropShadow: {
      type: Boolean,
      default: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "300px",
    },
  },
  data: function () {
    return {
      uid: utilities.getUniqueNumber(),
    };
  },
  computed: {
    containerId() {
      return `drawer-${this.uid}`
    },
    opened: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    calculatedOffset() {
      return this.offset;
    },
    renderShader() {
      // a little complicated.
      // if either is false - than false
      return !(!this.dropShadow || !this.shader);
    },
    hasHeaderContent() {
      return this.title || this.$slots["header-content"] || this.$slots["title"];
    },
    widthCssValue() {
      if (["left", "right", "inline-start", "inline-end"].includes(this.location)) {
        return this.width;
      } else {
        return "100%";
      }
    },
  },
  emits: ["update:modelValue"],
  methods: {
    close() {
      this.opened = false;
    },
  },
  beforeUnmount() {},
};
